import { createJSONStorage, persist } from "zustand/middleware";
import { create } from "zustand/react";

interface BotSelectionStore {
  selectedBotId: string | null;
  userEmail: string | null;
  setSelectedBot: (botId: string, userEmail: string) => void;
}

export const useBotSelectionStore = create<BotSelectionStore>()(
  persist(
    (set) => ({
      selectedBotId: null,
      userEmail: null,
      setSelectedBot: (botId, userEmail) => {
        set({ selectedBotId: botId, userEmail });
      },
    }),
    {
      name: "bot-selection",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
